import { Phase, SERVICE_MAP } from '@financial/service-origins';
import { APP_ENVIRONMENT } from './constants.mjs';

/**
 * @param phase: string // real, stage, dev, alpha, test, local ...
 * @returns https://new-m.pay.naver.com, https://new-beta-m.pay.naver.com, https://new-alpha-m.pay.naver.com
 * @description alpha, beta, real
 */
const getNewPayOrigin = function () {
  let phase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Phase.real;
  if (phase === Phase.real || phase === Phase.stage) {
    return SERVICE_MAP[phase].NEW_PAY;
  } else {
    return SERVICE_MAP[Phase.alpha].NEW_PAY;
  }
};
const getInitialAppEnv = supportApps => {
  if (supportApps.length === 1 && supportApps.includes('payapp')) {
    return APP_ENVIRONMENT.PAY_APP;
  }
  return APP_ENVIRONMENT.NAVER_APP;
};

/**
 * alpha: alpha, dev, local
 * beta: stage
 * real: real
 * test: test
 */
const convertPhase = phase => {
  switch (phase) {
    case 'local':
    case 'dev':
      return 'alpha';
    case 'stage':
      return 'beta';
    default:
      return phase;
  }
};

export { convertPhase, getInitialAppEnv, getNewPayOrigin };
